import dotProp from 'dot-prop-immutable'
import { MOVE_FRAME, MOVE_FRAME_SIMPLE, MOVE_SET, MOVE_SET_SIMPLE, SELECT_FRAME } from "../../constants/projectActions";
import { disallowToResize } from './resizable'

export const stopMovingFrame = (index, { x, y, ...rest }) => (dispatch, ownState) => {

  dispatch({ type: SELECT_FRAME, index })
  const isResizing = dotProp.get(ownState(), 'products.isResizing', false)

  if (!isResizing) {
    dispatch(disallowToResize())
    dispatch({ type: MOVE_FRAME, index, x, y })
  }
}

export const movingFrame = (index, { x, y, ...rest }) => (dispatch, ownState) => {

  dispatch({ type: SELECT_FRAME, index })
  const isResizing = dotProp.get(ownState(), 'products.isResizing', false)

  if (!isResizing) {
    dispatch(disallowToResize())
    dispatch({ type: MOVE_FRAME_SIMPLE, index, x, y })
  }
}

export const movingSet = (index, { x, y }) => (dispatch, ownState) => {
  dispatch({ type: SELECT_FRAME, index })
  const isResizing = dotProp.get(ownState(), 'products.isResizing', false)

  if (!isResizing) {
    dispatch(disallowToResize())
    dispatch({ type: MOVE_SET_SIMPLE, index, x, y })
  }
}

export const stopMovingSet = (index, { x, y }) => (dispatch, ownState) => {
  dispatch({ type: SELECT_FRAME, index })
  const isResizing = dotProp.get(ownState(), 'products.isResizing', false)

  if (!isResizing) {
    dispatch(disallowToResize())
    dispatch({ type: MOVE_FRAME, index, x, y })
  }
}



// WEBPACK FOOTER //
// ./src/actions/project/draggable.js